export type PaginationParams = {
  page: number;
  pageSize: number;
};

export enum SortDirection {
  ASC = 'ASCENDING',
  DESC = 'DESCENDING',
}

export enum ResponseCodes {
  ITEM_BLOCKED = 'ITEM_BLOCKED',
  USER_INVALID = 'USER_INVALID',
  PROJECT_SCOPE_MISMATCH = 'PROJECT_SCOPE_MISMATCH',
  REMEDIATION_ACTION_COULD_BE_REMOVED = 1002,
  SERVICE_TIER_USERS_LIMIT = 1003,
  NEED_SERVICE_TIER_TO_RESET_PROJECT = 1031,
  LINK_INVALID = 1040,
  LINK_EXPIRED = 1041,
  LINK_ALREADY_USED = 1042,
}

export const PROJECT_SCOPE_MISMATCH_MESSAGE =
  'This view is out of date and no changes were made. Reload the model and try again.';

export type ResponseError = {
  status: number;
  data: {
    message: string;
    code?: ResponseCodes;
  };
};
